import { render, staticRenderFns } from "./NXTCustomDeptUserSelector.vue?vue&type=template&id=3d77dd3e&scoped=true"
import script from "./NXTCustomDeptUserSelector.vue?vue&type=script&lang=js"
export * from "./NXTCustomDeptUserSelector.vue?vue&type=script&lang=js"
import style0 from "./NXTCustomDeptUserSelector.vue?vue&type=style&index=0&id=3d77dd3e&prod&scoped=true&lang=css"
import style1 from "./NXTCustomDeptUserSelector.vue?vue&type=style&index=1&id=3d77dd3e&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3d77dd3e",
  null
  
)

export default component.exports